import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ComponentProps, HTMLAttributes } from "react";

export const ArchiveTags = ({
    tags,
    tagEnums,
    color,
    className,
    ...props
}: {
    tags: string[] | null;
    tagEnums: Array<{ value: string; comment?: string | null }>;
    color?: ComponentProps<typeof Text>["color"];
} & HTMLAttributes<HTMLDivElement>) => {
    if (!tags || tags.length === 0) {
        return null;
    }

    // Create a map of tag values to their comments for quick lookup
    const tagMap = new Map(
        tagEnums
            .filter((tag) => tag.comment)
            .map((tag) => [tag.value, tag.comment!])
    );

    // Map color prop to Tailwind class if it's "primary.dark" or use Text's color prop
    const getColorClass = () => {
        if (color === "primary.dark" || !color) {
            return "text-primary-dark";
        }
        return undefined;
    };

    return (
        <div
            className={cn("flex items-center overflow-hidden", className)}
            {...props}
        >
            {tags.map((tagValue) => {
                const tagComment = tagMap.get(tagValue);
                if (!tagComment) return null;

                return (
                    <Text
                        key={tagValue}
                        variant="body4"
                        color={
                            color && color !== "primary.dark"
                                ? color
                                : undefined
                        }
                        className={cn(
                            getColorClass(),
                            "[&:not(:last-child)]:after:mx-1 [&:not(:last-child)]:after:content-['·']"
                        )}
                    >
                        {tagComment}
                    </Text>
                );
            })}
        </div>
    );
};
